export const formatCityStateCode = ({ city, stateCode }) => {
	const formattedCity = city.replace(/\s+/g, '-').replace(/[^'\w-]+/g, '');
	// we need to keep apostrophes in the city, as geo api does not find the location if apostrophe is stripped
	// Note the difference from St+John%27s and St+Johns from 1st to 2nd example
	// 1 - location found: geo/locations/city?city=St+John%27s&exact=true&state=NL
	// 2 - location NOT found: geo/locations/city?city=St+Johns&exact=true&state=NL

	return `${formattedCity}-${stateCode}`.toLowerCase();
};
